module.exports = __webpack_public_path__ + "static/recorded-data_fr-4960ba96e7c362d9d87cf5742b8c1ca4.svg";